import { Clock, Mail, MapPin, Phone } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const offices = [{
  name: "Shenzhen Innovation Center",
  address: "No. 7, Dongmao Road, Guangming District, Shenzhen",
  phone: "+1 (555) 123-4567",
  email: "hq@example.com",
  hours: "Mon-Fri: 9:00 AM - 6:00 PM (EST)"
}];
export default function ContactMap() {
  return <section id="contactmap" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="mb-12 text-center">
          <h2 className="font-default text-foreground mb-4 text-3xl font-bold tracking-tight sm:text-4xl">
            Our Locations
          </h2>
          <p className="text-muted-foreground mx-auto max-w-2xl text-lg">
            Find us at one of our global offices or get in touch with our team. We are always ready to help you.
          </p>
        </div>

        <div className="border-border mb-16 overflow-hidden rounded-xl border shadow-sm">
          <div className="hidden md:block">
            <AspectRatio ratio={21 / 9} className="bg-muted">
              <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d14744.444444444445!2d113.9545!3d22.6054!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2s!4v1710000000000!5m2!1sen!2s" className="h-full w-full border-0 grayscale filter" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Office Location Map" />
            </AspectRatio>
          </div>
          <div className="block md:hidden">
            <AspectRatio ratio={4 / 3} className="bg-muted">
              <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d14744.444444444445!2d113.9545!3d22.6054!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2s!4v1710000000000!5m2!1sen!2s" className="h-full w-full border-0 grayscale filter" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Office Location Map Mobile" />
            </AspectRatio>
          </div>
        </div>

        
      </div>
    </section>;
}